module.exports = __webpack_public_path__ + "img/40_69_011_650.bf0b17fb.jpg";